import React, { useState, useEffect } from 'react';

const allowedColors = [
  { name: 'Red', hex: '#ff0000' },
  { name: 'Blue', hex: '#0000ff' },
  { name: 'Pink', hex: '#ff007f' },
  { name: 'LightBlue(Default)', hex: '#38befe' }
];


const EdgeColorSelector = ({onColorChange}) => {
 const [selectedColor, setSelectedColor] = useState('');

  const handleColorChange = (colorHex) => {
    setSelectedColor(colorHex);
    if (onColorChange) {
      onColorChange(colorHex);
    }
  };


  return (
    <div>
      <div style={{ display: 'flex', gap: 8, marginLeft:"10px",marginRight:"10px"}}>
        {allowedColors.map((color) => (
          <button
            key={color.name}
            onClick={() => handleColorChange(color.hex)}
            style={{
              backgroundColor: color.hex,
              border: selectedColor === color.hex ? '3px solid black' : '1px solid #ccc',
              width: 30,
              height: 30,
              cursor: 'pointer',
              borderRadius:"5px"
            }}
            title={color.name}
          />
        ))}
      </div>
    </div>
  );
};

export default EdgeColorSelector;
